module.exports = __webpack_public_path__ + "img/icn-phone.90b435ef.svg";